export const RRP_ADD_PERMISSION = 'RRP_ADD_PERMISSION'
export const RRP_REMOVE_PERMISSION = 'RRP_REMOVE_PERMISSION'
export const RRP_CLEAR = 'RRP_CLEAR'
